var _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMobile(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 32,
    width: 32,
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cy: 16,
    cx: 16,
    fill: "#FFF",
    r: 16
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.466 22.919c-.225 0-.394.225-.394.506v.281c0 .282.169.507.394.507h1.125c.225 0 .393-.225.393-.507v-.281c0-.281-.168-.506-.393-.506zM12.034 9.25v12.881h7.875V9.25zm2.307-1.575v.056c-.113 0-.17.113-.17.225-.055.113.057.169.17.169h3.543c.113 0 .17-.113.17-.225 0-.113-.113-.225-.17-.225zM12.316 7h7.368c.563 0 1.07.506 1.07 1.125v15.75c0 .619-.45 1.125-1.07 1.125h-7.368c-.563 0-1.07-.506-1.07-1.125V8.125c0-.619.45-1.125 1.07-1.125z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobile);
export default ForwardRef;